// Pinned, browser-native OOXML renderer. It is bundled from the lockfile at
// build time—never downloaded or executed from a remote CDN at runtime.
export const PPTX_RENDERER_PACKAGE = '@aiden0z/pptx-renderer@1.2.4';

let rendererPromise = null;

export const loadPptxRenderer = () => {
  if (!rendererPromise) {
    rendererPromise = import('@aiden0z/pptx-renderer/browser').catch((error) => {
      rendererPromise = null;
      throw error;
    });
  }
  return rendererPromise;
};
